import React, { FC } from 'react';
import styled from 'styled-components';
import { SlideStatusDot } from '../NgIcons';

const StyledWrapper = styled.div<{ $ready: boolean; $clickable?: boolean; $active?: boolean; $large?: boolean }>`
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 2px 4px;
  border-radius: ${({ theme }) => theme.radius.button};
  border: 1px solid ${({ $active }) => ($active ? '#bfdbfe' : 'transparent')};
  background: ${({ $active }) => ($active ? '#eff6ff' : 'none')};
  cursor: ${({ $clickable }) => ($clickable ? 'pointer' : 'default')};

  .status-dot {
    color: ${({ theme, $ready }) => ($ready ? theme.palette.success : theme.palette.text)};
  }

  .status-label {
    font-size: ${({ theme, $large }) => ($large ? theme.fontSize.default : theme.fontSize.xs)};
    font-weight: ${({ $large }) => ($large ? 600 : 400)};
    color: ${({ theme }) => theme.palette.textMuted};
  }

  &:hover .status-label {
    text-decoration: ${({ $clickable }) => ($clickable ? 'underline' : 'none')};
  }
`;

interface StepStatusProps {
  label: string;
  ready?: boolean;
  active?: boolean;
  clickable?: boolean;
  large?: boolean;
  onClick?: () => void;
}

export const StepStatus: FC<StepStatusProps> = ({ label, ready = true, active, clickable, large, onClick }) => (
  <StyledWrapper $ready={ready} $active={active} $clickable={clickable} $large={large} onClick={onClick} className='step-status'>
    <span className="status-dot">
      <SlideStatusDot filled={ready} />
    </span>
    <span className="status-label">{label}</span>
  </StyledWrapper>
);
